import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const GrayQuestModal = ({ visible, onHide, title, message, severity }) => {
  // Define icon and header style based on severity
  let headerIcon;
  let headerClass = "flex align-items-center justify-content-center";
  
  if (severity === 'success') {
    headerIcon = "pi pi-check-circle";
    headerClass += " text-green-500";
  } else if (severity === 'error') {
    headerIcon = "pi pi-times-circle";
    headerClass += " text-red-500";
  } else if (severity === 'info') {
    headerIcon = "pi pi-info-circle";
    headerClass += " text-blue-500";
  } else {
    headerIcon = "pi pi-exclamation-circle";
    headerClass += " text-yellow-500";
  }

  // The footer with the OK button
  const footer = (
    <div>
      <Button 
        label="OK" 
        icon="pi pi-check" 
        onClick={onHide} 
        autoFocus 
        className={severity === 'error' ? 'p-button-danger' : 'p-button-primary'}
      />
    </div>
  );

  // The header with icon and title
  const header = (
    <div className={headerClass}>
      <i className={`${headerIcon} mr-2`} style={{ fontSize: '1.5rem' }}></i>
      <span className="font-bold">{title}</span>
    </div>
  );

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: '450px' }}
      modal
      footer={footer}
      onHide={onHide}
      closeOnEscape={false}
      closable={false}
      dismissableMask={false}
    >
      <div className="flex align-items-center justify-content-center">
        <p className="m-0">{message}</p>
      </div>
    </Dialog>
  );
};

export default GrayQuestModal;